import React from 'react';
import pt from 'prop-types';
import cx from 'classnames';
import Icon from 'components/icon';
import FadeIn from 'components/transitions/fade-in';

import './accordion.scss';

const CHEVRON_SIZE = 20;

export default class Accordion extends React.PureComponent {
  static propTypes = {
    label: pt.any.isRequired,
    labelButtonDisabled: pt.bool,
    className: pt.string,
    children: pt.any,
    headerRest: pt.any,
    headerRestPosition: pt.string,
    headerProps: pt.object,
    arrow: pt.bool,
    arrowPosition: pt.string,
    isOpen: pt.bool,
    onClickLabel: pt.func,
    onClickArrow: pt.func,
  };

  constructor(props) {
    super(props);

    this.state = {
      isOpen: false,
    };
  }

  static getDerivedStateFromProps(props, state) {
    if (typeof props.isOpen === 'boolean' && props.isOpen !== state.isOpen) {
      return { isOpen: props.isOpen };
    }

    return null;
  }

  onClickLabel = (event) => {
    const { onClickLabel, arrow = true } = this.props;
    const { isOpen } = this.state;

    if (!arrow) {
      this.setState({ isOpen: !isOpen });
    } else if (!isOpen) {
      this.setState({ isOpen: true });
    }

    onClickLabel?.(event);
  };

  onClickArrow = (event) => {
    const { onClickArrow } = this.props;

    this.setState({ isOpen: !this.state.isOpen });

    onClickArrow?.(event);
  };

  renderElementsWithPosition(position, elementA, elementB) {
    return position === 'right' ? (
      <>
        {elementA}
        {elementB}
      </>
    ) : (
      <>
        {elementB}
        {elementA}
      </>
    );
  }

  renderLabel() {
    const {
      label,
      labelButtonDisabled = false,
      headerRest,
      headerRestPosition = 'right',
    } = this.props;
    const labelButton = (
      // eslint-disable-next-line jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events
      <div
        className={cx('accordion-label-button', {
          disabled: labelButtonDisabled,
        })}
        onClick={this.onClickLabel}
      >
        {label}
      </div>
    );

    if (!headerRest) {
      return labelButton;
    }

    return this.renderElementsWithPosition(
      headerRestPosition,
      labelButton,
      headerRest,
    );
  }

  renderHeader() {
    const { arrow = true, arrowPosition = 'right' } = this.props;
    const { isOpen } = this.state;
    const label = this.renderLabel();

    if (!arrow) {
      return label;
    }

    const arrowButton = (
      <button
        type="button"
        className="accordion-arrow-button"
        onClick={this.onClickArrow}
      >
        <Icon
          fa={isOpen ? 'chevron-up' : 'chevron-down'}
          faSize="xs"
          width={CHEVRON_SIZE}
          height={CHEVRON_SIZE}
        />
      </button>
    );

    return this.renderElementsWithPosition(arrowPosition, label, arrowButton);
  }

  render() {
    const { className, children, headerProps = {} } = this.props;
    const { isOpen } = this.state;
    const shouldRenderBody = isOpen && children;

    return (
      <div className={cx('accordion', className, { open: isOpen })}>
        <div
          {...headerProps}
          className={cx('accordion-header', headerProps?.className)}
        >
          {this.renderHeader()}
        </div>
        {shouldRenderBody && (
          <FadeIn>
            <div className="accordion-body">{children}</div>
          </FadeIn>
        )}
      </div>
    );
  }
}
